module.exports = __webpack_public_path__ + "dashboard/img/refresh.75c32da465cc828205d0923925abc8dd.svg";